import assert = require("assert");
import chai = require("chai");
import utpTelemetry = require("../UTPTelemetry");
import sinon = require("sinon");
import { EnvironmentValues } from "../datacontracts/EnvironmentValues";
import { FeatureUsageEvent } from "../datacontracts/FeatureUsageEvent";
import { BusinessProcessEvent } from "../datacontracts/BusinessProcessEvent";
import { SystemEvent } from "../datacontracts/SystemEvent";
import { ComponentType } from "../datacontracts/ComponentType";

describe("UTPTelemetry", () =>{ 
   var UTPTelemetry = require("../UTPTelemetry");
   var UTPTelemetryInstance = undefined;
   var validEnvironmentValues = undefined;
   var invalidEnvironmentValues = undefined;
   var validTelemetryInstance = undefined;
   var invalidTelemetryInstance = undefined;
   beforeEach('Arrange all the dependencies', function(){
      invalidEnvironmentValues = new EnvironmentValues('Production', 'ServiceOffering', 'ServiceLine', 'Service', 'UTPComponent', '', '');
      validEnvironmentValues = new EnvironmentValues('Production', 'ServiceOffering', 'ServiceLine', 'Service', 'UTPComponent', 'some-random-guid', 'some-random-guid');
      validTelemetryInstance = new UTPTelemetry.UTPTelemetry('some-random-guid', validEnvironmentValues);
      invalidTelemetryInstance = new UTPTelemetry.UTPTelemetry('', invalidEnvironmentValues);
   });  
   afterEach(function(){

   });

   it('check for valid dependency data', () => {
      var logStub = sinon.stub(console, 'log');
      UTPTelemetryInstance = new UTPTelemetry.UTPTelemetry('some-random-guid', validEnvironmentValues);
      assert.ok(logStub.called);
   })

   it('check for invalid dependency data', () => {
      var errorStub = sinon.stub(console, 'error');
      UTPTelemetryInstance = new UTPTelemetry.UTPTelemetry('', validEnvironmentValues);
      assert.ok(errorStub.called);
   })

   it('TrackTrace with valid data', () => {
   let status = validTelemetryInstance.TrackTrace("Trace message");
   assert.equal(status, true);
   })

   it('TrackTrace with in-valid data', () => {
      let status = validTelemetryInstance.TrackTrace("");
      assert.equal(status, false);
   })

   it('TrackEvent with valid data', () => {
      let status = validTelemetryInstance.TrackEvent("Track message");
      assert.equal(status, true);
   })

   it('TrackEvent with in-valid data', () => {
      let status = validTelemetryInstance.TrackEvent("");
      assert.equal(status, false);
   })

   it('TrackMetric with valid data', () => {
      let status = validTelemetryInstance.TrackMetric("Metric message", 2 , 2);
      assert.equal(status, true);
   })

   it('TrackMetric with in-valid data', () => {
      let status = validTelemetryInstance.TrackMetric("", 2 , 2);
      assert.equal(status, false);
   })

   it('TrackRequest with valid data', () => {
      let status = validTelemetryInstance.TrackRequest("Request message", "http://mockurl", 5, "502", false);
      assert.equal(status, true);
   })

   it('TrackRequest with in-valid data', () => {
      let status = validTelemetryInstance.TrackRequest("", "http://mockurl", 5, "502", false);
      assert.equal(status, false);
   })

   it('TrackDependency with valid data', () => {
      let status = validTelemetryInstance.TrackDependency("Dependency message", "Type", "Data", 5, "502", true);
   assert.equal(status, true);
   })

   it('TrackDependency with in-valid data', () => {
      let status = validTelemetryInstance.TrackDependency("", "Type", "Data", 5, "502", true);
      assert.equal(status, false);
   })

   it('TrackException with valid data', () => {
      let status = validTelemetryInstance.TrackException("ExceptionName", "Message", "stack");
   assert.equal(status, true);
   })

   it('TrackException with in-valid data', () => {
      let status = validTelemetryInstance.TrackException("", "Message", "stack");
      assert.equal(status, false);
   })

   it('TrackFeatureUsageEvent with valid data', () => {
      let featureEvent: FeatureUsageEvent = new FeatureUsageEvent("FeatureEvent",ComponentType.Device);      
      let status = validTelemetryInstance.TrackFeatureUsageEvent(featureEvent);
      assert.equal(status, true);
   })

   it('TrackFeatureUsageEvent with in-valid data', () => {
      let featureEvent: FeatureUsageEvent = new FeatureUsageEvent("",ComponentType.Device);
      let status = validTelemetryInstance.TrackFeatureUsageEvent(featureEvent);
      assert.equal(status, false);
   })

   it('TrackBusinessProcessEvent with valid data', () => {
      let businessEvent: BusinessProcessEvent = new BusinessProcessEvent("BusinessProcessEvent",ComponentType.Device);
      businessEvent.AppAction = "AppAction";
      businessEvent.ReceiverId = "ReceiverId";
      businessEvent.SenderId = "SenderId";
      businessEvent.EventOccurrenceTime = new Date();
      let status = validTelemetryInstance.TrackBusinessProcessEvent(businessEvent);
      assert.equal(status, true);;
   })

   it('TrackBusinessProcessEvent with in-valid data', () => {
      let businessEvent: BusinessProcessEvent = new BusinessProcessEvent("",ComponentType.Device);
      let status = validTelemetryInstance.TrackBusinessProcessEvent(businessEvent);
      assert.equal(status, false);
   })

   it('TrackSystemEvent with valid data', () => {
      let systemEvent: SystemEvent = new SystemEvent("SystemEvent",ComponentType.Device);
      let status = validTelemetryInstance.TrackSystemEvent(systemEvent);
      assert.equal(status, true);
   })

   it('TrackSystemEvent with in-valid data', () => {
      let systemEvent: SystemEvent = new SystemEvent("",ComponentType.Device);
      let status = validTelemetryInstance.TrackSystemEvent(systemEvent);
      assert.equal(status, false);
   })
});

